module.exports = __webpack_public_path__ + "static/media/project_6.3ba9050e.webp";